<template>
    <div>
        <b-navbar type="dark" toggleable="lg">
            <b-navbar-toggle target="nav-collapse" @click="onNavButtonClick"></b-navbar-toggle>

            <b-navbar-brand class="logo-wrapper">
                <app-main-logo @OnFocus="onFocus" @onClick="onMainLogoClick"></app-main-logo>
            </b-navbar-brand>

            <b-collapse ref="mobileNav" id="nav-collapse" is-nav>
                <b-navbar-nav :class="{ 'is-collapsed': toggleState }">

                    <template v-for="(item, index) in getNavigation">

                        <!-- Single item -->
                        <b-nav-item
                                v-bind:key="index"
                                v-if="item.type === 'link'"
                                @focus="onFocus"
                                :href="getRoutePath(item.routeName)"
                                v-on:click.prevent="onNavItemClick(item.routeName)"
                                :class="{ 'is-active': isNavItemActive(item.activeRoutes) }">

                            {{ item.label }}
                        </b-nav-item>

                        <!-- Dropdown item -->
                        <b-nav-item-dropdown
                                v-bind:key="index"
                                v-if="item.type === 'dropdown'"
                                @mouseover.native="hoverNavItem(item.label)"
                                @mouseleave.native="hoverLeaveNavItem(item.label)"
                                @focus="onFocus"
                                :text="item.label"
                                left
                                :ref="constructDropdownRef(item.label)"
                                :class="{ 'is-active': isNavItemActive(item.activeRoutes) }">

                            <li><span class="arrow-wrapper"><span class="arrow"></span></span></li>

                            <b-dropdown-item v-for="(subItem, index) in item.subItems" v-bind:key="index"
                                             @focus="onFocus"
                                             :href="getRoutePath(subItem.routeName)"
                                             v-on:click.prevent="onNavItemClick(subItem.routeName)"
                                             :class="{ 'is-active':
                                         isNavItemActive(subItem.activeRoutes) }">

                                {{ subItem.label }}
                            </b-dropdown-item>
                        </b-nav-item-dropdown>
                    </template>

                </b-navbar-nav>
            </b-collapse>
        </b-navbar>

    </div>
</template>

<script>
    import {mixinRoutesHandler} from '@/mixins/routes-handler';
    import AppMainLogo from '@/components/ui/logo/AppMainLogo';

    export default {
        name: 'Nav',

        mixins: [mixinRoutesHandler],

        components: {
            AppMainLogo,
        },

        data: function() {
            return {
                navSettings: [
                    { routeName: 'Loyalty' },
                    {
                        label: 'Solutions',
                        sub: [
                            'Airlines',
                            'Financial',
                            'Hospitality',
                            'Malls',
                            'Telecom',
                            'Media',
                        ]
                    },
                    { routeName: 'TheTechnology' },
                    { routeName: 'Compliance' },
                    { routeName: 'ClientsAndCases' },
                    { routeName: 'News' },
                    {
                        label: 'Investor',
                        sub: [
                            'CertifiedAdviser',
                            'CorporateGovernance',
                            'FinancialCalendar',
                            'Ipo',
                            'InvestorRelationsContact',
                            'Nasdaq',
                            'Ownership',
                            'ReportsAndPresentations',
                            'Shares',
                        ]
                    },
                    {
                        label: 'About',
                        sub: [
                            'AboutUs',
                            'Careers',
                            'Contact',
                        ]
                    },
                ],

                navigationDropdownsRefs: [],
                navigation: [],

                toggleState: false,
                routeNameActive: null,
                disabledNav: false,
            }
        },

        methods: {
            constructDropdownRef(ref) {
              return `${ref}Dropdown`;
            },

            getRoutesObject(routeNames) {
                return this._mixinRoutesHandler_getRoutesFiltered(routeNames);
            },

            hoverNavItem(ref) {
                if (!this.isMobileNav()) {
                    this.$refs[this.constructDropdownRef(ref)][0].show();
                }
            },
            
            hoverLeaveNavItem(ref) {
                if (!this.isMobileNav()) {
                    this.$refs[this.constructDropdownRef(ref)][0].hide();
                }
            },

            isNavItemActive(routeNames) {
                return routeNames.includes(this.routeNameActive);
            },

            /* Actions */
            onMainLogoClick() {
                if (this.$refs.mobileNav.show) {
                    this.$refs.mobileNav.toggle();
                    this.resetToggleState();
                }
            },

            onFocus() {
                this.$emit('OnHeaderElementFocus', true);
            },

            updateToggleState() {
                this.toggleState = !this.toggleState;
            },

            resetToggleState() {
                this.toggleState = false;
            },

            toggleClassOnBody() {
                let element = document.getElementsByTagName("body")[0];

                if (this.toggleState) {
                    element.classList.add("nav-is-collapsed");
                } else {
                    element.classList.remove("nav-is-collapsed");
                }
            },

            closeDropdownNav() {
                const dropdownRefs = this.navigationDropdownsRefs;

                dropdownRefs.forEach((x) => {
                    this.$refs[x][0].hide();
                });
            },

            getRoutePath(routeName) {
                return this._mixinGetRoutePath(routeName)
            },

            /* Events */
            onNavItemClick(routeName) {
                this._mixinGoToRouteName(routeName);
                this.resetToggleState();
            },

            onNavButtonClick() {
                this.updateToggleState();
            },

            onWindowResize() {
                // Reset collapse when resize gets bigger than mobile breakpoint
                if (window.innerWidth > 991) {
                    this.resetToggleState();
                }
            },

            onWindowScroll() {
                this.closeDropdownNav();
            },

            isMobileNav() {
                return window.innerWidth < 991;
            },

            setNavigation() {
                const nav = this.navSettings;

                let navigation              = [];
                let navigationDropdownsRefs = [];

                nav.forEach((navItem) => {
                    if ('routeName' in navItem) {
                        const route = this.getRoutesObject([navItem.routeName]);

                        let children = [];

                        if ('childrenRoutes' in route[0]) {
                            children = route[0].childrenRoutes;
                        }

                        navigation.push({
                            type: 'link',
                            routeName: route[0].name,
                            label: route[0].ui.label,
                            activeRoutes: [route[0].name, ...children],
                        });

                    } else {
                        const routes = this.getRoutesObject(navItem.sub);

                        let activeRoutes = [...navItem.sub];
                        let sub          = [];

                        routes.forEach((route) => {
                            // Route has children routes, push route names to active array.
                            if ('childrenRoutes' in route) {
                                activeRoutes.push(...route.childrenRoutes);

                                sub.push({
                                    routeName: route.name,
                                    label: route.ui.label,
                                    activeRoutes: [route.name, ...route.childrenRoutes],
                                });
                            } else {
                                sub.push({
                                    routeName: route.name,
                                    label: route.ui.label,
                                    activeRoutes: [route.name],
                                });
                            }

                        });

                        if (sub.length > 0) {
                            navigation.push({
                                type: 'dropdown',
                                label: navItem.label,
                                activeRoutes: activeRoutes,
                                subItems: sub
                            });

                            navigationDropdownsRefs.push(this.constructDropdownRef(navItem.label))
                        }
                    }

                });

                this.navigationDropdownsRefs = navigationDropdownsRefs;
                this.navigation = navigation;
            },
        },

        computed: {
            getNavigation() {
                return this.navigation;
            },
        },

        created() {
            window.addEventListener("scroll", this.onWindowScroll);
            window.addEventListener("resize", this.onWindowResize);
        },

        destroyed() {
            window.removeEventListener("scroll", this.onWindowScroll);
            window.removeEventListener("resize", this.onWindowResize);
        },

        mounted() {
            this.setNavigation();
        },

        watch: {
            'toggleState': function () {
                this.toggleClassOnBody();
            },

            $route(to) {
                this.routeNameActive = to.name;
            },
        }
    }
</script>

<style lang="scss">
    @import "@/assets/scss/components/layout/header/nav";

    .is-collapsed {
        overflow-y: scroll;
        height: 100vh;
        padding-bottom: 150px;
    }

    .nav-item {
        .arrow-wrapper {
            width: 100%;
            position: absolute;
            top: -15px;
            left: 50%;
            height: 15px;
            transform: translate(-50%, 0);
        }
    }

    @media (min-width: 992px) {
        .nav-item {
            &:last-child {
                .dropdown-menu {
                    left: -200px;
                }

                .arrow-wrapper {
                    transform: translate(-19%, 0);
                }
            }
        }
    }

    @media (min-width: 1115px) {
        .nav-item {
            &:last-child {
                .dropdown-menu {
                    left: -100px;
                }

                .arrow-wrapper {
                    transform: translate(-50%, 0);
                }
            }
        }
    }
</style>
